import parseDialogue from "../../util/parseDialogue";

export const SuperphreakC1 = parseDialogue(`
superphreak:c1:100-500

#100 Hey, not bad ~~~~ ~~~~ so far ~~~~ You're almost ~~~~~~ ready for level two ~~~~~~~~ access.
>200 Thanks.

#200 Hmm ~~ something ~~ ~~~~~~ weird's going on. I think I ~~~ breaking up. ~~~~~~~ Look, you've got ~~~ get the access codes. We've put ~~ program there ~~~ help ~~~~~ out.
>300 Where do I find the codes?
>300 What's wrong?

#300 You ~~~~ can find ~~~~ ~ ~~~~~~ ~~~ ~~~~~~~ ~~~ ~~~~~~~~
>400 Superphreak? Hello?
>400 Where do I find the codes?

#400 ~~~~~~~~~ ~~~~ ~~~~ ~~~~~~~~ ~ ~~~ ~~~~~~~>brk
>500 Close.
`);
